var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlimitedData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 15,
    viewBox: "0 0 29 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8817 14.2591C19.6527 14.2591 17.5724 13.2175 16.235 11.5064L12 7.19147L16.3093 2.95089C18.6126 -0.173736 23.0705 -0.768904 26.191 1.53737C29.3115 3.84365 29.9059 8.30741 27.6026 11.432C26.191 13.2175 24.1106 14.2591 21.8817 14.2591ZM21.8074 2.95089C20.47 2.95089 19.2069 3.54606 18.3897 4.58761L15.7892 7.19147L18.3897 9.72093C19.2069 10.7625 20.47 11.432 21.8074 11.3576C24.1106 11.3576 26.0424 9.49774 26.0424 7.11707C26.0424 4.88519 24.1849 2.95089 21.8074 2.95089Z",
    fill: "#F68140"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9405 11.4675C9.70085 14.5856 5.57141 15.1795 2.63181 12.8038C-0.30779 10.4281 -0.867715 6.04791 1.37198 2.92981C3.61168 -0.188296 7.74112 -0.782221 10.6807 1.59347C11.1707 1.96468 11.5906 2.41012 11.9405 2.92981L16 7.16151L11.9405 11.4675ZM9.91082 4.71158C9.14093 3.67221 7.95109 3.00404 6.69126 3.07829C4.52156 3.07829 2.7018 4.9343 2.7018 7.30999C2.7018 9.68569 4.45156 11.5417 6.69126 11.5417C7.95109 11.5417 9.14093 10.9478 9.91082 9.90841L12.3605 7.38424L9.91082 4.71158Z",
    fill: "#F68140"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlimitedData);
export default __webpack_public_path__ + "static/media/unlimited_data.1327e745839de7ce6a108e5226c4a689.svg";
export { ForwardRef as ReactComponent };